import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const CustomTable = ({
  rows,
  columns,
  loading,
  meta,
  onChange,
  rowSelection = false,
  selectedRows,
  setSelectedRows,
  setDeleteSelected,
  ...props
}) => {
  // Pagination
  const handlePaginationModelChange = (model) => {
    onChange({
      page: model.page + 1,
      pageSize: model.pageSize,
      query: meta.query || {},
      sort: meta.sort,
      search: meta.search,
    });
  };

  // Sorting
  const handleSortModelChange = (sortModel) => {
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0];
      onChange({
        page: meta.pagination.page,
        pageSize: meta.pagination.pageSize,
        query: meta.query || {},
        sort: { field, order: sort },
        search: meta.search,
      });
    } else {
      onChange({
        page: meta.pagination.page,
        pageSize: meta.pagination.pageSize,
        query: meta.query || {},
        sort: null,
        search: meta.search,
      });
    }
  };

  // Quick Filter/Search (from toolbar)
  const handleFilterChange = (filterModel) => {
    const search = filterModel.quickFilterValues?.[0] || "";
    onChange({
      page: 1,
      pageSize: meta.pagination.pageSize,
      query: meta.query || {},
      sort: meta.sort,
      search,
    });
  };

  // Selection
  const handleRowSelection = (selected) => {
    setSelectedRows?.(selected);
    setDeleteSelected?.(selected.length > 0);
  };

  return (
    <DataGrid
      sx={{ minHeight: 580 }}
      rows={rows}
      columns={columns}
      loading={loading}
      paginationMode="server"
      sortingMode="server"
      pageSize={meta.pagination.pageSize}
      rowCount={meta.pagination.total}
      paginationModel={{
        page: meta.pagination.page - 1,
        pageSize: meta.pagination.pageSize,
      }}
      onPaginationModelChange={handlePaginationModelChange}
      onSortModelChange={handleSortModelChange}
      filterMode="server"
      onFilterModelChange={handleFilterChange}
      slots={{ toolbar: GridToolbar }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
          csvOptions: { disableToolbarButton: true },
          printOptions: { disableToolbarButton: true },
        },
      }}
      pageSizeOptions={[10]}
      disableColumnFilter
      // Only enable row selection if the prop is true
      {...(rowSelection
        ? {
          checkboxSelection: true,
          onRowSelectionModelChange: handleRowSelection,
        }
        : {})}
      {...props}
    />
  );
};

export default CustomTable;
